module.exports = __webpack_public_path__ + "img/CVX.b3158d68.png";